/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_Err_RateInputs */

const en_cp_form_err_rate = /** @type {(inputs: Cp_Form_Err_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many attempts. Try again later.`)
};

const id_cp_form_err_rate = /** @type {(inputs: Cp_Form_Err_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlalu banyak percobaan. Coba lagi nanti.`)
};

/**
* | output |
* | --- |
* | "Too many attempts. Try again later." |
*
* @param {Cp_Form_Err_RateInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_err_rate = /** @type {((inputs?: Cp_Form_Err_RateInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_Err_RateInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_err_rate(inputs)
	return en_cp_form_err_rate(inputs)
});